import { Fancybox, Carousel } from "@fancyapps/ui";

document.addEventListener("DOMContentLoaded", () => {
  try {
    // ── Mobile carousel ──
    const mobileMainEl  = document.querySelector("#mainCarousel-mobile");
    const mobileThumbEl = document.querySelector("#thumbCarousel");

    let mobileCarousel = null;
    if (mobileMainEl) {
      mobileCarousel = new Carousel(mobileMainEl, { Dots: false, infinite: false });
    }
    if (mobileThumbEl && mobileCarousel) {
      new Carousel(mobileThumbEl, {
        Sync: { target: mobileCarousel, friction: 0 },
        Dots: false, Navigation: false,
        center: true, slidesPerPage: 1, infinite: false,
      });
    }
    Fancybox.bind('[data-fancybox="gallery"]', {
      Carousel: mobileCarousel ? {
        on: { change: (that) => {
          mobileCarousel.slideTo(mobileCarousel.findPageForSlide(that.page), { friction: 0 });
        }},
      } : undefined,
    });

    // ── Desktop carousel ──
    const desktopMainEl  = document.querySelector("#mainCarousel");
    const desktopThumbEl = document.querySelector("#thumbCarousel-desktop");

    let desktopCarousel = null;
    if (desktopMainEl) {
      desktopCarousel = new Carousel(desktopMainEl, { Dots: false, infinite: false });
    }
    if (desktopThumbEl && desktopCarousel) {
      new Carousel(desktopThumbEl, {
        Sync: { target: desktopCarousel, friction: 0 },
        Dots: false, Navigation: false,
        center: true, slidesPerPage: 1, infinite: false,
      });
    }
    Fancybox.bind('[data-fancybox="gallery-desktop"]', {
      Carousel: desktopCarousel ? {
        on: { change: (that) => {
          desktopCarousel.slideTo(desktopCarousel.findPageForSlide(that.page), { friction: 0 });
        }},
      } : undefined,
    });

  } catch (e) {
    console.error("Carousel/Fancybox init error:", e);
  }
});